import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, ScrollText } from 'lucide-react';
import './Navbar.css';

const Navbar: React.FC = () => {
  const location = useLocation();

  const links = useMemo(() => ([
    {
      key: 'home',
      label: '\u0635\u0641\u062d\u0647 \u0627\u0635\u0644\u06cc',
      to: '/',
      icon: Home
    },
    {
      key: 'store',
      label: '\u0641\u0631\u0648\u0634\u06af\u0627\u0647',
      to: '/store',
      icon: ShoppingBag
    },
    {
      key: 'rules',
      label: '\u0642\u0648\u0627\u0646\u06cc\u0646',
      to: '/rules',
      icon: ScrollText
    }
  ]), []);

  const activeIndex = location.pathname.startsWith('/store') ? 1 : location.pathname.startsWith('/rules') ? 2 : 0;

  const renderLinks = () =>
    links.map((link) => {
      const isActive = link.to === '/' ? location.pathname === '/' : location.pathname.startsWith(link.to);
      const Icon = link.icon;
      return (
        <li key={link.key}>
          <Link
            to={link.to}
            className={`navbar-link ${isActive ? 'is-active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
          >
            <span className="navbar-link__icon" aria-hidden="true">
              <Icon size={18} />
            </span>
            <span className="navbar-link__label">{link.label}</span>
          </Link>
        </li>
      );
    });

  return (
    <nav className="navbar-blue" aria-label="ناوبری اصلی">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" aria-label="SculkMC">
          <img src="/icon/sculkmc.png" alt="" />
          <span className="brand-word" lang="en">SculkMC</span>
        </Link>
        <ul className="navbar-menu">
          <li className="navbar-indicator" aria-hidden="true" style={{ transform: `translateX(calc(${activeIndex} * (-100% - 4px)))` }} />
          {renderLinks()}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 








